<div class="master-search-container d-flex flex-column">
  <div class="d-flex justify-content-between align-items-center">
    <span class="master-search-text">Master Search</span>
    <div class="img-container" mat-dialog-close (click)="onClose()">
      <img
        src="../../../assets/images/crossIconDarkTheme.svg"
        class="cross-icon"
      />
    </div>
  </div>

  <div class="received-data d-flex flex-wrap">
    <span><strong>Name:</strong> {{data.name}}&nbsp;,&nbsp;</span>
    <span><strong>Ritwik:</strong> {{data.ritwikName}}&nbsp;,&nbsp;</span>
    <span><strong>Address:</strong> {{data.address}}</span>
  </div>

  <ul class="tab-list">
    <li
      class="tab-link"
      [ngClass]="{ linkTabactive: activeTab === 'globalSearch' }"
      (click)="activeTab = 'globalSearch'"
    >
      Global search
    </li>
    <li
      class="tab-link"
      [ngClass]="{ linkTabactive: activeTab === 'nameSearch' }"
      (click)="activeTab = 'nameSearch'"
    >
      Name search
    </li>
    <li
      class="tab-link"
      [ngClass]="{ linkTabactive: activeTab === 'keywordSearch' }"
      (click)="activeTab = 'keywordSearch'"
    >
      Keyword search
    </li>
    <div class="horizontal-border"></div>
  </ul>

  <ng-container *ngIf="activeTab === 'globalSearch'">
    <global-search-tab [data]="data" (serialNo)="onClickSerialNo($event)"></global-search-tab>
  </ng-container>

  <ng-container *ngIf="activeTab === 'nameSearch'">
    <name-search-tab (serialNo)="onClickSerialNo($event)"></name-search-tab>
  </ng-container>

  <ng-container *ngIf="activeTab === 'keywordSearch'">
    <keyword-search-tab (serialNo)="onClickSerialNo($event)"></keyword-search-tab>
  </ng-container>
</div>
